//import ViewDetailStudyListPopup from "@/pages/comp/plan/study/study/popup/view_detail_study_list";
import ViewDetailStudyListArea from "@/pages/comp/plan/study/study/common/view_detail_study_list";

function ViewDetailStudyListPopup(props: any) {
  let myProps = {
    stu_seq:"",
    study_title_seq:"",
    callBackData:(inData:any)=>{},
    closePopup: () => {},
    ...props
  };

  return (
    <div>
      <ViewDetailStudyListArea
        stu_seq={myProps.stu_seq}
        study_title_seq={myProps.study_title_seq}
        on_click_close={myProps.closePopup}
      ></ViewDetailStudyListArea>
    </div>
  );
};
export default ViewDetailStudyListPopup;